import {
  AGREEMENTS,
  DECISION_ACT,
  DECISION_COMPLAINT,
  DECISION_EVENTS,
  DECISION_INFO,
  DECISION_RESULT,
  DECISION_VIOLATIONS,
  KNM_DOCUMENTS,
  KNM_EPGU_NOTIFICATION,
  KNM_HISTORY,
  KNM_JUDGMENTS,
  KNM_OBJECTS_INFO,
  KNM_SIGN_INFO,
  KNM_VERIFIED_PERSON,
  REPEAT_PASSPORTS,
} from 'CorePackage/MainModule/routes/routes';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { insertItemAfterIdInPlace } from 'KnmErknmPackage/KnmErknmMenuModule/constants/insertItemAfterIdInPlace';

import { DecisionMenuItemsIdsEnum } from '../enums/DecisionMenuItemsIdsEnum';
import { IDecisionMenuItem } from '../interfaces/IDecisionMenuItem';

export const basicDecisionMenuItems = (
  created: string | null | undefined,
  settings: IAdminSetting[] | undefined,
): IDecisionMenuItem[] => {
  const agreementsStartFrom = settings?.find(
    x => x.code === AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_16_STARTS_FROM,
  )?.value;

  const repeatPassportsStartFrom = settings?.find(
    x => x.code === AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM,
  )?.value;

  const isEnableAgreements =
    Boolean(agreementsStartFrom) &&
    isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_16_STARTS_FROM);
  const isEnablePrescriptionCheck =
    Boolean(repeatPassportsStartFrom) &&
    isLaterThanAdminSetting(created, settings, AdminSettingCodesEnum.KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM);

  const items = [
    {
      id: DecisionMenuItemsIdsEnum.DECISION_INFO,
      route: `#${DECISION_INFO}`,
      title: 'Общая информация',
    },
    {
      id: DecisionMenuItemsIdsEnum.KNM_OBJECTS_INFO,
      route: `#${KNM_OBJECTS_INFO}`,
      title: 'Сведения об объектах контроля',
    },
    {
      id: DecisionMenuItemsIdsEnum.KNM_VERIFIED_PERSON,
      route: `#${KNM_VERIFIED_PERSON}`,
      title: 'Сведения о контролируемом лице',
    },
    {
      id: DecisionMenuItemsIdsEnum.DECISION_EVENTS,
      route: `#${DECISION_EVENTS}`,
      title: 'Перечень осуществленных действий',
    },
    {
      id: DecisionMenuItemsIdsEnum.DECISION_VIOLATIONS,
      route: `#${DECISION_VIOLATIONS}`,
      title: 'Нарушенные требования',
    },
    {
      id: DecisionMenuItemsIdsEnum.DECISION_ACT,
      route: `#${DECISION_ACT}`,
      title: 'Сведения об акте',
    },
    {
      id: DecisionMenuItemsIdsEnum.KNM_DOCUMENTS,
      route: `#${KNM_DOCUMENTS}`,
      title: 'Документы',
    },
    {
      id: DecisionMenuItemsIdsEnum.DECISION_RESULT,
      route: `#${DECISION_RESULT}`,
      title: 'Сведения о решении',
    },
    {
      id: DecisionMenuItemsIdsEnum.KNM_SIGN_INFO,
      route: `#${KNM_SIGN_INFO}`,
      title: 'Сведения о подписании',
    },
    {
      id: DecisionMenuItemsIdsEnum.KNM_EPGU_NOTIFICATION,
      route: `#${KNM_EPGU_NOTIFICATION}`,
      title: 'Сведения об информировании',
    },
    {
      id: DecisionMenuItemsIdsEnum.DECISION_COMPLAINT,
      route: `#${DECISION_COMPLAINT}`,
      title: 'Сведения о жалобах',
    },
    {
      id: DecisionMenuItemsIdsEnum.KNM_JUDGMENTS,
      route: `#${KNM_JUDGMENTS}`,
      title: 'Сведения о судебных решениях',
    },
    {
      id: DecisionMenuItemsIdsEnum.KNM_HISTORY,
      route: `#${KNM_HISTORY}`,
      title: 'История изменений',
    },
  ];

  if (isEnableAgreements) {
    insertItemAfterIdInPlace<IDecisionMenuItem>(items, DecisionMenuItemsIdsEnum.DECISION_RESULT, {
      id: DecisionMenuItemsIdsEnum.AGREEMENTS,
      route: `#${AGREEMENTS}`,
      title: 'Сведения о соглашениях',
    });
  }

  if (isEnablePrescriptionCheck) {
    insertItemAfterIdInPlace<IDecisionMenuItem>(items, DecisionMenuItemsIdsEnum.KNM_JUDGMENTS, {
      id: DecisionMenuItemsIdsEnum.REPEAT_PASSPORTS,
      route: `#${REPEAT_PASSPORTS}`,
      title: 'Перечень повторных мероприятий',
    });
  }

  return items;
};
